<div class="relative w-full bg-white p-12 shadow-lg mt-[80px]">
    <div class="max-w-7xl mx-auto flex items-center justify-start">
        <h1 class="text-3xl font-bold text-gray-900 aarni-font">{{pageTitle}}</h1>
    </div>
</div>

<div class="modal-overlay" *ngIf="isModalOpen" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <!-- Close Button -->
        <button class="close-button" (click)="closeModal()" aria-label="Close modal">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>

        <!-- Main Image -->
        <div class="slider-container">
            <button class="nav-button prev" (click)="prevImage()" aria-label="Previous image">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>

            <div class="slide">
                <img [src]="environment?.s3_bucket_url+images[currentImageIndex]?.partial_url"
                     [alt]="images[currentImageIndex]?.title"
                     class="modal-image"
                     loading="lazy"
                     (load)="onImageLoad()"
                     (error)="imageLoaded = true">
                <div class="image-loader" *ngIf="!imageLoaded">
                    <div class="loader"></div>
                </div>
            </div>

            <button class="nav-button next" (click)="nextImage()" aria-label="Next image">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>

        <!-- Image Info -->
        <div class="image-info">
            <h3 class="image-title">{{ images[currentImageIndex]?.title }}</h3>
            <p class="image-counter">Image {{ currentImageIndex + 1 }} of {{ images.length }}</p>
        </div>

        <!-- Thumbnails -->
        <div class="thumbnails-container">
            <div class="thumbnails">
                <div *ngFor="let image of images; let i = index"
                     class="thumbnail"
                     [class.active]="i === currentImageIndex"
                     (click)="selectImage(i)"
                     [attr.aria-label]="'View image ' + (i + 1)">
                    <img [src]="environment.s3_bucket_url+image?.partial_url" [alt]="image?.title" loading="lazy">
                </div>
            </div>
        </div>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-orange-500">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Get To Know Arni</h2>
                    <div class="">
                        <a (click)="goTo('/quick-links/image-gallery')"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Image Gallery', 'text-blue-600 bg-white' : pageTitle !== 'Image Gallery'}"
                           class="flex items-center space-x-2 cursor-pointer p-3 w-full text-blue-600 border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Image Gallery</span>
                        </a>
                        <a [href]="'/quick-links/video-gallery'"
                           [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Video Gallery', 'text-blue-600 bg-white' : pageTitle !== 'Video Gallery'}"
                           class="flex items-center space-x-2 cursor-pointer p-3 w-full text-blue-600 border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300">
                            <i class="fa fa-arrow-right"></i>
                            <span>Video Gallery</span>
                        </a>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/about/faculty" class="flex items-center  space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-chalkboard-teacher text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Faculty</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium text-xl pl-4">Testimonials</span>
                    </a>
                </div>
            </div>

            <!--<div class="bg-white p-4 rounded-lg shadow border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="#" class="flex items-center space-x-3 p-2 rounded-lg">
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Job Openings</span>
                    </a>
                </div>
            </div>-->
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block  border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="about/leadership/chancellor" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-user-tie text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Leadership</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block  border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
            <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span>
                        <span class="text-gray-700 font-medium pl-4 text-xl">Contact Us</span>
                    </a>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-6 border-2 border-gray-200 rounded-lg">
            <div *ngIf="pageTitle === 'Image Gallery'">

                <!--                <div class="max-w-6xl mx-auto justify-center">-->
                <!--                    <div *ngFor="let gallery of galleries;"-->
                <!--                         class="grid gap-6 my-3 align-middle"-->
                <!--                         [ngClass]="{'sm:grid-cols-2 sm:justify-center md:grid-cols-3': gallery?.images?.length > 0}">-->
                <!--                        <div class="bg-white shadow-lg rounded-lg overflow-hidden" (click)="openModal(gallery?.images)">-->
                <!--                            <img src="{{gallery?.images[0]?.url}}" alt="Republic Day" class="w-full h-52 object-cover">-->
                <!--                            <div class="p-4">-->
                <!--                                <p class="text-lg font-semibold">{{ gallery?.title }}</p>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="max-w-6xl mx-auto px-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        <div *ngFor="let gallery of galleries"
                             class="bg-white shadow-lg rounded-lg overflow-hidden transition-transform duration-300 hover:scale-105 cursor-pointer"
                             (click)="openModal(gallery?.files)">
                            <img src="{{ environment.s3_bucket_url + gallery?.files[0]?.partial_url}}"
                                 alt="{{gallery?.title}}"
                                 class="w-full h-52 object-cover">
                            <div class="p-4">
                                <p class="text-lg font-semibold text-gray-800">{{ gallery?.title }}</p>
                                <p class="text-sm text-gray-500 mt-1">{{ gallery?.files?.length }} photos</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex justify-center mt-6">
                    <nav class="inline-flex items-center space-x-2 border rounded-lg p-2">
                        <button
                            (click)="prevPage()"
                            [disabled]="currentPage === 1"
                            class="px-3 py-1 rounded text-red-500 hover:bg-gray-200 disabled:opacity-50">
                            «
                        </button>
                        <ng-container *ngFor="let page of pages">
                            <button
                                (click)="goToPage(page)"
                                [ngClass]="{'bg-red-500 text-white': currentPage === page, 'text-red-500': currentPage !== page}"
                                class="px-3 py-1 rounded hover:bg-gray-200">
                                {{ page }}
                            </button>
                        </ng-container>
                        <button
                            (click)="nextPage()"
                            [disabled]="currentPage === totalPages"
                            class="px-3 py-1 rounded text-red-500 hover:bg-gray-200 disabled:opacity-50">
                            »
                        </button>
                    </nav>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-8" *ngIf="pageTitle === 'Video Gallery'">
                <div *ngFor="let video of videosYoutube" class="cursor-pointer group" (click)="playVideo(video.link, video.title,video.description)">
                    <div class="relative">
                        <img [src]="video.thumbnail" [alt]="video.title" class="w-full rounded-lg shadow-md group-hover:opacity-75 transition duration-300" />
                        <div
                            class="absolute inset-0 flex items-center justify-center">
                            <div class="relative flex items-center justify-center w-16 h-16 bg-white rounded-full cursor-pointer">
                                <span class="absolute w-16 h-16 border-2 border-white rounded-full animate-ping"></span>
                                <span class="absolute w-16 h-16 border-2 border-white rounded-full animate-ping delay-500"></span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    class="w-6 h-6 text-black z-10"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path d="M8 5v14l11-7z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                    <p class="mt-4 text-center text-sm font-semibold">{{ video.title }}</p>
                </div>
            </div>

            <div
                *ngIf="selectedVideo"
                class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-4"
            >
                <div class="relative w-full max-w-5xl mx-auto">
                    <div class="flex justify-end mb-2">
                        <button
                            (click)="closeVideo()"
                            class="text-white text-2xl font-bold border border-white rounded-md w-10 h-10 flex items-center justify-center hover:bg-white hover:text-black transition"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="relative w-full pt-[56.25%] rounded-lg shadow-lg overflow-hidden">
                        <iframe
                            [src]="sanitizedVideoUrl"
                            class="absolute top-0 left-0 w-full h-full"
                            frameborder="0"
                            allow="autoplay; encrypted-media"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="mt-6 text-center text-white">
                        <p class="text-xl font-semibold">{{ selectedVideo.title }}</p>
                        <p class="text-sm mt-1">{{selectedVideo.description}}</p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
